import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";

import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatIconModule } from "@angular/material/icon";

import { KpiComponent } from "./kpi.component";
import { ValueFormatDecimalsPipeModule } from '../../pipes/valueFormatDecimals/value-format-decimals.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MatCardModule,
    MatProgressBarModule,
    MatIconModule,
    ValueFormatDecimalsPipeModule
  ],
  declarations: [KpiComponent],
  exports: [KpiComponent],
})
export class KpiModule {}
